import {
  POLICYRISKITEM_INIT_LOADING,
  POLICYRISKITEM_INIT_SUCCESS,
  POLICYRISKITEM_INIT_FAIL,
  POLITEM_SAVE_LOADING,
  POLITEM_SAVE_SUCCESS,
  POLITEM_SAVE_FAIL,
  POLITEMSTATS_SAVE_LOADING,
  POLITEMSTATS_SAVE_SUCCESS,
  POLITEMSTATS_SAVE_FAIL,
  POLITEMUOM_SAVE_LOADING,
  POLITEMUOM_SAVE_SUCCESS,
  POLITEMUOM_SAVE_FAIL,
  POLITEM_SET_DATA,
  POLITEMUOM_SET_DATA,
  POLSUBITEM_INIT_LOADING,
  POLSUBITEM_INIT_SUCCESS,
  POLSUBITEM_INIT_FAIL,
  POLSUBITEM_SAVE_LOADING,
  POLSUBITEM_SAVE_SUCCESS,
  POLSUBITEM_SAVE_FAIL,
  POLITEMBEN_SAVE_LOADING,
  POLITEMBEN_SAVE_SUCCESS,
  POLITEMBEN_SAVE_FAIL
} from '@/store/types'

export const item = {
  [POLICYRISKITEM_INIT_LOADING](state) {
    state.policyRiskItemSettings.init = 0
    state.policyRiskItemSettings.initErr = []
    state.policyRiskItemSettings.menu = {}
  },
  [POLICYRISKITEM_INIT_SUCCESS](state, data) {
    state.policyRiskItemSettings.init = 1
    state.policyRiskItemSettings.initErr = []
    state.policyRiskItemSettings.menu = data.menu
  },
  [POLICYRISKITEM_INIT_FAIL](state, error) {
    state.policyRiskItemSettings.init = 2
    state.policyRiskItemSettings.initErr = error
    state.policyRiskItemSettings.menu = {}
  },
  [POLITEM_SAVE_LOADING](state) {
    state.policy.polItem.init = 0
    state.policy.polItem.saving = true
    state.policy.polItem.saveError.fieldMessages = []
    state.policy.polItem.saveError.messages = []
  },
  [POLITEM_SAVE_SUCCESS](state) {
    state.policy.polItem.init = 1
    state.policy.polItem.saving = false
    state.policy.polItem.saveError.fieldMessages = []
    state.policy.polItem.saveError.messages = []
  },
  [POLITEM_SAVE_FAIL](state, errMsgs) {
    state.policy.polItem.init = 2
    state.policy.polItem.saving = false
    state.policy.polItem.saveError.fieldMessages = errMsgs.fieldMessages
    state.policy.polItem.saveError.messages = errMsgs.messages
  },
  [POLITEMSTATS_SAVE_LOADING](state) {
    state.policy.polItemStats.init = 0
    state.policy.polItemStats.saving = true
    state.policy.polItemStats.saveError.fieldMessages = []
    state.policy.polItemStats.saveError.messages = []
  },
  [POLITEMSTATS_SAVE_SUCCESS](state) {
    state.policy.polItemStats.init = 1
    state.policy.polItemStats.saving = false
    state.policy.polItemStats.saveError.fieldMessages = []
    state.policy.polItemStats.saveError.messages = []
  },
  [POLITEMSTATS_SAVE_FAIL](state, errMsgs) {
    state.policy.polItemStats.init = 2
    state.policy.polItemStats.saving = false
    state.policy.polItemStats.saveError.fieldMessages = errMsgs.fieldMessages
    state.policy.polItemStats.saveError.messages = errMsgs.messages
  },
  [POLITEMUOM_SAVE_LOADING](state) {
    state.policy.polItemUOM.init = 0
    state.policy.polItemUOM.saving = true
    state.policy.polItemUOM.saveError.fieldMessages = []
    state.policy.polItemUOM.saveError.messages = []
    state.policy.polItemUOM.saveError.types = []
  },
  [POLITEMUOM_SAVE_SUCCESS](state) {
    state.policy.polItemUOM.init = 1
    state.policy.polItemUOM.saving = false
    state.policy.polItemUOM.saveError.fieldMessages = []
    state.policy.polItemUOM.saveError.messages = []
    state.policy.polItemUOM.saveError.types = []
  },
  [POLITEMUOM_SAVE_FAIL](state, errMsgs) {
    state.policy.polItemUOM.init = 2
    state.policy.polItemUOM.saving = false
    state.policy.polItemUOM.saveError.fieldMessages = errMsgs.fieldMessages
    state.policy.polItemUOM.saveError.messages = errMsgs.messages
    state.policy.polItemUOM.saveError.types = errMsgs.types
  },
  [POLITEM_SET_DATA](state, data) {
    state.policy.polItem.stdItemTxtRef = data.stdItemTxtRef
    state.policy.polItem.stdItemTxtLn = data.stdItemTxtLn
  },
  [POLITEMUOM_SET_DATA](state, data) {
    state.policy.polItemUOM.uom = data.uom
    state.policy.polItemUOM.uomShortDesc = data.uomShortDesc
    state.policy.polItemUOM.uomVal = data.uomVal
  },
  [POLSUBITEM_INIT_LOADING](state) {
    state.policySubItemSettings.init = 0
    state.policySubItemSettings.initErr = []
    state.policySubItemSettings.menu = {}
  },
  [POLSUBITEM_INIT_SUCCESS](state, data) {
    state.policySubItemSettings.init = 1
    state.policySubItemSettings.initErr = []
    state.policySubItemSettings.menu = data.menu
  },
  [POLSUBITEM_INIT_FAIL](state, error) {
    state.policySubItemSettings.init = 2
    state.policySubItemSettings.initErr = error
    state.policySubItemSettings.menu = {}
  },
  [POLSUBITEM_SAVE_LOADING](state) {
    state.policy.polSubItem.init = 0
    state.policy.polSubItem.saving = true
    state.policy.polSubItem.saveError.fieldMessages = []
    state.policy.polSubItem.saveError.messages = []
    state.policy.polSubItem.saveError.types = []
  },
  [POLSUBITEM_SAVE_SUCCESS](state) {
    state.policy.polSubItem.init = 1
    state.policy.polSubItem.saving = false
    state.policy.polSubItem.saveError.fieldMessages = []
    state.policy.polSubItem.saveError.messages = []
    state.policy.polSubItem.saveError.types = []
  },
  [POLSUBITEM_SAVE_FAIL](state, errMsgs) {
    state.policy.polSubItem.init = 2
    state.policy.polSubItem.saving = false
    state.policy.polSubItem.saveError.fieldMessages = errMsgs.fieldMessages
    state.policy.polSubItem.saveError.messages = errMsgs.messages
    state.policy.polSubItem.saveError.types = errMsgs.types
  },
  [POLITEMBEN_SAVE_LOADING](state) {
    state.policy.polItemBen.init = 0
    state.policy.polItemBen.saving = true
    state.policy.polItemBen.saveError.fieldMessages = []
    state.policy.polItemBen.saveError.messages = []
  },
  [POLITEMBEN_SAVE_SUCCESS](state) {
    state.policy.polItemBen.init = 1
    state.policy.polItemBen.saving = false
    state.policy.polItemBen.saveError.fieldMessages = []
    state.policy.polItemBen.saveError.messages = []
  },
  [POLITEMBEN_SAVE_FAIL](state, errMsgs) {
    state.policy.polItemBen.init = 2
    state.policy.polItemBen.saving = false
    state.policy.polItemBen.saveError.fieldMessages = errMsgs.fieldMessages
    state.policy.polItemBen.saveError.messages = errMsgs.messages
  }
}
